var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": "right",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "评价月",
                                        prop: "monthList",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "multiple_sel",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            multiple: "",
                                            placeholder: "请选择(支持多选)",
                                          },
                                          model: {
                                            value: _vm.queryCondition.monthList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "monthList",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.monthList",
                                          },
                                        },
                                        _vm._l(
                                          _vm.monthOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item,
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "QIP单据编号",
                                        prop: "qipCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "支持模糊查询",
                                        },
                                        model: {
                                          value: _vm.queryCondition.qipCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "qipCode",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.qipCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "DC编号",
                                        prop: "dcCodeList",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "multiple_sel",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            multiple: "",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.queryCondition.dcCodeList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "dcCodeList",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.dcCodeList",
                                          },
                                        },
                                        _vm._l(
                                          _vm.dcCodeListOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.dcCode,
                                                value: item.dcCode,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "供应商名称",
                                        prop: "supplierName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "支持模糊查询",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.supplierName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "supplierName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.supplierName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "产品名称",
                                                prop: "eightBitCodeName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .eightBitCodeName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "eightBitCodeName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.eightBitCodeName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "产品类别",
                                                prop: "category2CodeList",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "multiple_sel",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    multiple: "",
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .category2CodeList,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "category2CodeList",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.category2CodeList",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.category2CodeOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "不合格原因",
                                                prop: "causeOfNonconformityList",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TT_QSPI_QIP",
                                                  field:
                                                    "CAUSE_OF_NONCONFORMITY",
                                                  multiple: "",
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .causeOfNonconformityList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "causeOfNonconformityList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.causeOfNonconformityList",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "风险等级",
                                                prop: "riskGrade",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TT_QSPI_QIP",
                                                  field: "RISK_GRADE",
                                                  clearable: "",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .riskGrade,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "riskGrade",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.riskGrade",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: { label: "问题产品数量" },
                                            },
                                            [
                                              _c(
                                                "el-row",
                                                {
                                                  attrs: {
                                                    type: "flex",
                                                    align: "middle",
                                                    justify: "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 10 } },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.queryCondition
                                                              .minQuantity,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.queryCondition,
                                                              "minQuantity",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "queryCondition.minQuantity",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                      attrs: { span: 2 },
                                                    },
                                                    [
                                                      _c("p", {
                                                        staticStyle: {
                                                          height: "1px",
                                                          background: "#000",
                                                          "text-align":
                                                            "center",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 10 } },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.queryCondition
                                                              .maxQuantity,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.queryCondition,
                                                              "maxQuantity",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "queryCondition.maxQuantity",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "单位",
                                                prop: "mcdBuyingUnit",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  table: "TM_MATERIAL_RECORD",
                                                  field: "MCD_BUYING_UNIT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .mcdBuyingUnit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "mcdBuyingUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.mcdBuyingUnit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "责任方",
                                                prop: "responsiblePartyList",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TT_QSPI_QIP",
                                                  field: "RESPONSIBLE_PARTY",
                                                  placeholder: "请选择",
                                                  multiple: "",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .responsiblePartyList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "responsiblePartyList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.responsiblePartyList",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "承运商",
                                                prop: "carrierCode",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .carrierCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "carrierCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.carrierCode",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.carrierCodeOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          item.supplierName,
                                                        value:
                                                          item.supplierCode,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "反馈结果",
                                                prop: "feedbackResults",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .feedbackResults,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "feedbackResults",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.feedbackResults",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.feedbackResultsOptions,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "状态",
                                                prop: "statusList",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TT_QSPI_QIP",
                                                  field: "STATUS",
                                                  excludes: _vm.excludesValue,
                                                  placeholder: "请选择",
                                                  clearable: "",
                                                  multiple: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .statusList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "statusList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.statusList",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "FSC反馈状态",
                                                prop: "fscFeedbackStatus",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TT_QSPI_QIP",
                                                  field: "FSC_FEEDBACK_STATUS",
                                                  excludes: _vm.excludesValue,
                                                  placeholder: "请选择",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .fscFeedbackStatus,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "fscFeedbackStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.fscFeedbackStatus",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.ms_emplFlag !== "SUP"
                                        ? _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "责任方是否已确定",
                                                    prop: "responsibleConfirm",
                                                  },
                                                },
                                                [
                                                  _c("ic-select", {
                                                    staticClass: "multiple_sel",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      table: "TT_QSPI_QIP",
                                                      field:
                                                        "RESPONSIBLE_CONFIRM",
                                                      excludes:
                                                        _vm.excludesValue,
                                                      placeholder: "请选择",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryCondition
                                                          .responsibleConfirm,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryCondition,
                                                          "responsibleConfirm",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryCondition.responsibleConfirm",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _vm.ms_roles.indexOf("QSPI_QIP_DC_QS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_ADD,
                          expression: "QSPI_QIP_ADD",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onAdd },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_QIP_DC_QS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_DEL,
                          expression: "QSPI_QIP_DEL",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "danger" },
                      on: { click: _vm.onDel },
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_QIP_DC_QS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_SUBMIT,
                          expression: "QSPI_QIP_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QSPI_QIP_IMPORT,
                      expression: "QSPI_QIP_IMPORT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onBatchUpload },
                },
                [_vm._v("批量导入")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QSPI_QIP_EXPORT,
                      expression: "QSPI_QIP_EXPORT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onExport },
                },
                [_vm._v("导出")]
              ),
              _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_RELEASE,
                          expression: "QSPI_QIP_RELEASE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onIssue },
                    },
                    [_vm._v("下发")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_CHECKED,
                          expression: "QSPI_QIP_CHECKED",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onVerificationCompleted },
                    },
                    [_vm._v("核实完成")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_BATCH_SAVE,
                          expression: "QSPI_QIP_BATCH_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onBatchModify },
                    },
                    [_vm._v("批量修改")]
                  )
                : _vm._e(),
              _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QIP_INVALID,
                          expression: "QSPI_QIP_INVALID",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onVoid },
                    },
                    [_vm._v("作废")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: (_vm.QSPI_QIP_SUPPLIER, _vm.QSPI_QIP_CARRIER),
                      expression: "QSPI_QIP_SUPPLIER,QSPI_QIP_CARRIER",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onNoObjection },
                },
                [_vm._v("无异议(支持多选)")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: (_vm.QSPI_QIP_SUPPLIER, _vm.QSPI_QIP_CARRIER),
                      expression: "QSPI_QIP_SUPPLIER,QSPI_QIP_CARRIER",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onObjection },
                },
                [_vm._v("有异议")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QSPI_QIP_GEN_TASK,
                      expression: "QSPI_QIP_GEN_TASK",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onCreatGrade },
                },
                [_vm._v("生成月度等级")]
              ),
              _vm.ms_Permission.indexOf("QSPI_QIP_CONRECP") > -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onReject("Y")
                        },
                      },
                    },
                    [_vm._v("条件收货")]
                  )
                : _vm._e(),
              _vm.ms_Permission.indexOf("QSPI_QIP_REJRECP") > -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onReject("N")
                        },
                      },
                    },
                    [_vm._v("拒收")]
                  )
                : _vm._e(),
              _vm.isAssistedDecision
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onCqsConfirm },
                    },
                    [_vm._v("邀请CQS协助判定")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              attrs: {
                data: _vm.tableData,
                checkboxConfig: {
                  checkMethod: _vm.selectable,
                  highlight: true,
                },
                "cell-class-name": _vm.setCellClass,
                "max-height": "600",
                "show-overflow": "tooltip",
                "highlight-current-row": "",
              },
              on: {
                "selection-change": _vm.selectionChange,
                "cell-click": _vm.cellClick,
              },
            },
            [
              _c("ux-table-column", {
                attrs: { align: "center", type: "checkbox", width: "80" },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "评价月",
                  resizable: "",
                  "min-width": "100",
                  field: "month",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "QIP单据编号",
                  resizable: "",
                  "min-width": "120",
                  field: "qipCode",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDetail(row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.qipCode))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "供应商名称",
                  resizable: "",
                  "min-width": "160",
                  field: "supplierName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Facility名称",
                  resizable: "",
                  "min-width": "160",
                  field: "facilityName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "产品名称",
                  resizable: "",
                  "min-width": "160",
                  field: "eightBitCodeName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "产品类别",
                  resizable: "",
                  "min-width": "90",
                  field: "category2Name",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "不合格原因",
                  resizable: "",
                  "min-width": "160",
                  field: "causeOfNonconformityI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "风险等级",
                  resizable: "",
                  "min-width": "100",
                  field: "riskGrade",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "问题产品数量",
                  resizable: "",
                  "min-width": "100",
                  field: "quantity",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "单位",
                  resizable: "",
                  "min-width": "120",
                  field: "mcdBuyingUnitI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "责任方",
                  resizable: "",
                  "min-width": "90",
                  field: "responsibleParty",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "承运商",
                  resizable: "",
                  "min-width": "90",
                  field: "carrierName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "QIP日期",
                  resizable: "",
                  "min-width": "120",
                  field: "qipDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "产品生产日期",
                  resizable: "",
                  "min-width": "130",
                  field: "productionDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "产品编号",
                  resizable: "",
                  "min-width": "90",
                  field: "eightBitCode",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "发现环节",
                  resizable: "",
                  "min-width": "120",
                  field: "discoveryLinkI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "处理方式",
                  resizable: "",
                  "min-width": "120",
                  field: "processingModeI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "备注",
                  resizable: "",
                  "min-width": "150",
                  field: "remarks",
                },
              }),
              _vm.ms_roles.indexOf("QSPI_QIP_OWNER") !== -1
                ? _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "QIP_Owner备注",
                      resizable: "",
                      "min-width": "150",
                      field: "ownerRemarks",
                    },
                  })
                : _vm._e(),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "状态",
                  resizable: "",
                  "min-width": "90",
                  field: "statusI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "反馈结果",
                  resizable: "",
                  "min-width": "120",
                  field: "feedbackResults",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "FSC反馈状态",
                  resizable: "",
                  "min-width": "120",
                  field: "fscFeedbackStatusI18n",
                },
              }),
              _vm.ms_emplFlag !== "SUP"
                ? _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "责任方是否已确定",
                      resizable: "",
                      "min-width": "120",
                      field: "responsibleConfirmI18n",
                    },
                  })
                : _vm._e(),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新人",
                  resizable: "",
                  "min-width": "120",
                  field: "updateName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新时间",
                  resizable: "",
                  "min-width": "90",
                  field: "updateDate",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                  "page-count": _vm.pages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "维护异议",
            visible: _vm.dialogObjectVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogObjectVisible = $event
            },
            close: _vm.onCloseObject,
          },
        },
        [
          _vm.dialogObjectVisible
            ? _c("feedback-Dialog", {
                attrs: {
                  userId: _vm.userId,
                  idList: _vm.idList,
                  proposeResponsibleParty: _vm.proposeResponsibleParty,
                },
                on: { onCloseObject: _vm.onCloseObject },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量修改",
            visible: _vm.dialogBatchVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBatchVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _vm.dialogBatchVisible
            ? _c("modify-Dialog", {
                attrs: { idList: _vm.idList },
                on: { onClose: _vm.onClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogTit === "Y"
                ? "条件收货"
                : _vm.dialogTit === "N"
                ? "拒收"
                : "邀请CQS协助判定",
            visible: _vm.dialogReVisable,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReVisable = $event
            },
            close: _vm.onCloseReject,
          },
        },
        [
          _vm.dialogReVisable
            ? _c("reject-dialog", {
                attrs: { idList: _vm.idList, dialogTit: _vm.dialogTit },
                on: { onCloseReject: _vm.onCloseReject },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入",
            visible: _vm.dialogBatchUploadVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBatchUploadVisible = $event
            },
            close: _vm.onClose1,
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-upload",
                {
                  ref: "batchUpload",
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "10px",
                  },
                  attrs: {
                    headers: _vm.header,
                    action: _vm.uploadUrl,
                    "on-success": _vm.uploadSuccess,
                    "on-change": _vm.handleChange,
                    "before-upload": _vm.beforeUpload,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    "show-file-list": false,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("选取文件")]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.qipTemplateDownload },
                },
                [_vm._v("模板下载")]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.uploadForm.fileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "fileName", $$v)
                      },
                      expression: "uploadForm.fileName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", [
            _c("h4", [_vm._v("说明:")]),
            _c("ul", [
              _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
              _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
              _c("li", [_vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M")]),
              _c("li", [
                _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
              ]),
              _c("li", [
                _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
              ]),
            ]),
          ]),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onUpload },
                },
                [_vm._v("上传")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onClose1 },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }